// Plikami — mécanisme anti-perdition n°4 (spec section 4) : le bloc « Vu
// récemment ». Seul usage de localStorage autorisé sur le site
// (docs/plikami-regles.md, Interdits) — mémorise jusqu'à 8 produits, du
// plus récent au plus ancien, dédupliqués par handle.
(() => {
  const STORAGE_KEY = 'plikami:vu-recemment';
  const MAX_ENTRIES = 8;

  const readCurrentProduct = () => {
    const node = document.querySelector('[data-plikami-vu-recemment-courant]');
    if (!node) return null;

    try {
      const data = JSON.parse(node.textContent);
      return data && data.handle ? data : null;
    } catch (error) {
      return null;
    }
  };

  const readStoredProducts = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  // Fait remonter le produit courant en tête plutôt que de le dupliquer,
  // et retourne le tableau complet (produit courant compris) : la liste
  // affichée l'exclut séparément, juste avant le rendu.
  const memorizeCurrentProduct = (current, stored) => {
    const withoutCurrent = stored.filter((item) => item && item.handle !== current.handle);
    const updated = [current, ...withoutCurrent].slice(0, MAX_ENTRIES);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch (error) {
      // Stockage indisponible (navigation privée stricte, quota atteint) :
      // le produit courant ne sera simplement pas mémorisé cette fois.
    }

    return updated;
  };

  const renderList = (products) => {
    if (products.length === 0) return;

    const section = document.getElementById('plikami-vu-recemment');
    const list = document.getElementById('plikami-vu-recemment-liste');
    const template = document.getElementById('plikami-vu-recemment-modele');
    if (!section || !list || !template) return;

    const fragment = document.createDocumentFragment();

    products.forEach((product) => {
      const item = template.content.cloneNode(true);
      const card = item.querySelector('.plikami-vu-recemment__carte');
      const image = item.querySelector('.plikami-vu-recemment__image');
      const nom = item.querySelector('.plikami-vu-recemment__nom');
      const prix = item.querySelector('.plikami-vu-recemment__prix');

      card.href = product.url;
      nom.textContent = product.title;
      prix.textContent = product.price;

      if (product.image) {
        image.src = product.image;
        image.alt = product.title;
      } else {
        image.remove();
      }

      fragment.appendChild(item);
    });

    list.appendChild(fragment);
    section.hidden = false;
  };

  const current = readCurrentProduct();
  if (!current) return;

  const stored = readStoredProducts();
  const updated = memorizeCurrentProduct(current, stored);
  const toDisplay = updated.filter((item) => item.handle !== current.handle);

  renderList(toDisplay);
})();
